import React, { memo } from 'react';
import { FadeIn } from './FadeIn';
export function OfferSection() {
  return <section id="offer" className="bg-brand-navy text-white py-24 px-6 relative overflow-hidden" data-id="element-142">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[800px] bg-brand-teal/10 rounded-full blur-3xl pointer-events-none" data-id="element-143"></div>

      <div className="max-w-3xl mx-auto text-center relative z-10" data-id="element-144">
        <FadeIn data-id="element-145">
          <h2 className="text-3xl md:text-5xl font-bold mb-8 leading-tight text-white" data-id="element-146">
            Stop the "screen time" battles and start the business journey.
          </h2>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-147">
          <p className="text-xl md:text-2xl text-gray-300 mb-12 leading-relaxed" data-id="element-148">
            Give your teen a resume-building skill that pays for itself in the
            first week of their first client.
          </p>
        </FadeIn>

        <FadeIn delay={0.3} data-id="element-149">
          <div className="bg-white/10 backdrop-blur-sm border border-white/20 rounded-2xl p-6 md:p-8 max-w-2xl mx-auto mb-12" data-id="element-150">
            <p className="text-lg md:text-xl text-gray-200 leading-relaxed text-center italic" data-id="element-151">
              We genuinely want to see more parents involved with their
              teenagers — building memories <em data-id="element-152">and</em> professionals together.
              This guide is our first step toward that mission, and this is the{' '}
              <strong className="text-brand-teal" data-id="element-153">First Edition</strong> — so
              we're making it as accessible as possible.
            </p>
          </div>
        </FadeIn>

        <FadeIn delay={0.4} data-id="element-154">
          <div className="bg-white text-brand-navy p-10 md:p-14 rounded-3xl shadow-2xl max-w-2xl mx-auto" data-id="element-155">
            <div className="inline-block bg-brand-teal/10 text-brand-teal font-bold text-sm uppercase tracking-widest px-4 py-1.5 rounded-full mb-6" data-id="element-156">
              First Edition Pricing
            </div>

            <div className="text-lg font-bold text-brand-gray uppercase tracking-wider mb-3" data-id="element-157">
              Total Investment
            </div>
            <div className="flex items-center justify-center gap-4 mb-2" data-id="element-158">
              <span className="text-2xl md:text-3xl text-red-400/70 line-through font-bold" data-id="element-159">
                $24.98
              </span>
              <span className="text-6xl md:text-7xl font-bold text-brand-navy" data-id="element-160">
                $6.39
              </span>
            </div>
            <p className="text-brand-teal font-bold text-sm mb-8" data-id="element-161">
              You save over 74% — First Edition only
            </p>

            <a href="https://www.scrolltoskills.com/cart/44722359828525:1" target="_blank" rel="noopener noreferrer" className="block w-full bg-brand-teal text-white font-bold text-xl md:text-2xl py-5 px-8 rounded-2xl shadow-[0_4px_14px_0_rgba(0,212,170,0.39)] hover:shadow-[0_6px_20px_rgba(0,212,170,0.23)] hover:bg-[#00e6b8] transition-all duration-300 transform hover:-translate-y-1 mb-6 text-center" data-id="element-162">
              GET THE REVERSE-SCROLL METHOD NOW
            </a>

            <p className="text-brand-gray font-medium flex items-center justify-center gap-2" data-id="element-163">
              <span className="w-2 h-2 rounded-full bg-brand-teal animate-pulse" data-id="element-164"></span>
              Instant PDF Download — Start the Audit Tonight
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}